import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Mail, Clock, ExternalLink } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="py-12 px-4 border-t border-gray-800 bg-gray-950" data-testid="site-footer">
      <div className="container mx-auto max-w-6xl">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <img src="/assets/smartvolt-logo.png" alt="SmartVolt Academy" className="h-10 mb-3" loading="lazy" />
            <p className="text-gray-500 text-sm leading-relaxed">
              DGUV-konforme Pflichtschulungen für Elektrobetriebe.
            </p>
            <div className="flex items-center gap-2 mt-3 text-xs text-gray-600">
              <Shield className="w-3.5 h-3.5 text-green-600" />
              SSL-verschlüsselt
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-white text-sm mb-3">Schulungen</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/kurse" className="hover:text-yellow-500 transition">Alle Kurse</Link></li>
              <li><Link to="/#pricing" className="hover:text-yellow-500 transition">14-Tage-Testzugang</Link></li>
              <li><Link to="/partner" className="hover:text-yellow-500 transition">Für Organisationen</Link></li>
              <li><Link to="/zertifikat-pruefen" className="hover:text-yellow-500 transition">Zertifikat prüfen</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white text-sm mb-3">Rechtliches</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/legal/impressum" className="hover:text-yellow-500 transition" data-testid="footer-impressum-link">Impressum</Link></li>
              <li><Link to="/legal/datenschutz" className="hover:text-yellow-500 transition" data-testid="footer-datenschutz-link">Datenschutzerklärung</Link></li>
              <li><Link to="/legal/agb" className="hover:text-yellow-500 transition" data-testid="footer-agb-link">AGB</Link></li>
              <li>
                <button
                  type="button"
                  onClick={() => window.openCookieSettings && window.openCookieSettings()}
                  className="hover:text-yellow-500 transition text-left"
                  data-testid="footer-cookie-settings"
                >
                  Cookie-Einstellungen
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white text-sm mb-3">Kontakt</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li className="flex items-center gap-2">
                <Mail className="w-3.5 h-3.5 text-gray-600" />
                <a href="mailto:smartvolt-academy@gmx.net" className="hover:text-yellow-500 transition">smartvolt-academy@gmx.net</a>
              </li>
              <li className="flex items-center gap-2">
                <Clock className="w-3.5 h-3.5 text-gray-600" />
                Mo–Fr 8:00–18:00
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-gray-600">
          <span>&copy; {new Date().getFullYear()} SmartVolt Academy. Alle Rechte vorbehalten.</span>
          <div className="flex items-center gap-4">
            <Link to="/legal/impressum" className="hover:text-gray-400 transition">Impressum</Link>
            <Link to="/legal/datenschutz" className="hover:text-gray-400 transition">Datenschutz</Link>
            <Link to="/legal/agb" className="hover:text-gray-400 transition">AGB</Link>
            <button
              type="button"
              onClick={() => window.openCookieSettings && window.openCookieSettings()}
              className="hover:text-gray-400 transition"
              data-testid="footer-cookie-settings-bottom"
            >
              Cookie-Einstellungen
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
